(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('white-apple-hero')) {
  customElements.define('white-apple-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.captions = [...this.querySelectorAll('[data-hero-caption]')];
      this.dots = [...this.querySelectorAll('[data-hero-dot]')];
      this.status = this.querySelector('[data-hero-status]');
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.position = this.target = this.index;
      this.velocity = 0;
      this.frame = null;
      this.dragFrame = null;
      this.drag = null;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.measure = () => {
        this.stride = (this.slides[0]?.offsetWidth || this.clientWidth) + 30;
        this.renderPosition();
      };
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(this);
      this.measure();
      this.classList.add('is-ready');
      this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.select(this.target - 1), options);
      this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.select(this.target + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), options));
      this.addEventListener('keydown', event => {
        if (!event.target.closest('[data-hero-dot]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.goTo(0);
        else if (event.key === 'End') this.goTo(this.slides.length - 1);
        else this.select(this.target + (event.key === 'ArrowRight' ? 1 : -1));
        this.dots[this.index]?.focus();
      }, options);
      // Touch Events keep the gesture alive when mobile browsers cancel their
      // compatibility Pointer Events while deciding whether to scroll the page.
      this.addEventListener('pointerdown', event => { if (event.pointerType !== 'touch') this.pointerDown(event); }, options);
      this.ownerDocument.addEventListener('pointermove', event => { if (event.pointerType !== 'touch') this.pointerMove(event); }, { ...options, passive: false });
      this.ownerDocument.addEventListener('pointerup', event => { if (event.pointerType !== 'touch') this.pointerEnd(event, true); }, options);
      this.ownerDocument.addEventListener('pointercancel', event => { if (event.pointerType !== 'touch') this.pointerEnd(event, false); }, options);
      this.addEventListener('touchstart', event => {
        if (event.touches.length !== 1) { this.cancelDrag(); return; }
        this.pointerDown(this.touchPoint(event.touches[0], event));
      }, { ...options, passive: true });
      this.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) { this.cancelDrag(); return; }
        const touch = [...event.touches].find(point => point.identifier === this.drag?.id);
        if (!touch) return;
        // Once native vertical scrolling has started, leave it with the browser.
        if (!event.cancelable) { this.cancelDrag(); return; }
        this.pointerMove(this.touchPoint(touch, event));
      }, { ...options, passive: false });
      this.addEventListener('touchend', event => {
        const touch = [...event.changedTouches].find(point => point.identifier === this.drag?.id);
        if (touch) this.pointerEnd(this.touchPoint(touch, event), true);
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => this.cancelDrag(), options);
      this.addEventListener('click', event => {
        if (!this.suppressClick || event.detail === 0) return;
        this.suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { ...options, capture: true });
      window.addEventListener('blur', () => this.cancelDrag(), options);
      this.addEventListener('dragstart', event => { if (event.target.closest('.hero-frame')) event.preventDefault(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        if (slide && this.contains(slide)) this.goTo(this.slides.indexOf(slide), false);
      }, options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.finish(); }, options);
      this.querySelectorAll('.hero-caption__button').forEach(button => this.bindButton(button, options));
      this.updateSelection(false);
      this.addEventListener('carousel:advance', () => this.select(this.target + 1, false), options);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      if (this.dragFrame !== null) window.cancelAnimationFrame(this.dragFrame);
      this.frame = null;
      this.drag = null;
      this.classList.remove('is-dragging');
      this.querySelectorAll('.hero-caption__button-fill').forEach(fill => fill.getAnimations().forEach(animation => animation.cancel()));
    }

    wrap(value) { return this.slides.length ? ((value % this.slides.length) + this.slides.length) % this.slides.length : 0; }

    goTo(index, announce = true) {
      if (!this.slides.length) return;
      const nearestCycle = Math.round((this.position - index) / this.slides.length);
      this.select(index + nearestCycle * this.slides.length, announce);
    }

    select(target, announce = true) {
      if (!this.slides.length) return;
      this.target = target;
      this.updateSelection(announce);
      if (this.motion.matches || this.slides.length === 1) this.finish();
      else this.startMotion();
    }

    updateSelection(announce) {
      this.index = this.wrap(this.target);
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.captions.forEach((caption, index) => {
        const active = index === this.index;
        caption.hidden = !active;
        caption.inert = !active;
        caption.classList.toggle('is-active', active);
      });
      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-pressed', String(active));
        dot.tabIndex = active ? 0 : -1;
      });
      const color = this.slides[this.index]?.dataset.slideControlColor;
      if (color) this.style.setProperty('--hero-control-color', color);
      const mobileRatio = this.slides[this.index]?.dataset.slideMobileRatio;
      if (mobileRatio) this.style.setProperty('--hero-mobile-ratio', mobileRatio);
      if (announce && this.status) this.status.textContent = this.slides[this.index]?.dataset.slideLabel || '';
    }

    renderPosition() {
      const count = this.slides.length;
      if (!count) return;
      this.slides.forEach((slide, index) => {
        const offset = index - this.position;
        const wrapped = offset - Math.round(offset / count) * count;
        slide.style.setProperty('--hero-slide-shift', `${wrapped * this.stride}px`);
      });
    }

    startMotion() {
      if (this.motion.matches) { this.finish(); return; }
      if (this.frame !== null) return;
      this.lastFrameTime = null;
      const tick = time => {
        this.frame = null;
        const elapsed = this.lastFrameTime === null ? 1 / 60 : Math.min(0.064, (time - this.lastFrameTime) / 1000);
        this.lastFrameTime = time;
        // Integrate a critically damped spring at the display's actual refresh rate.
        // Unlike fixed 60 Hz steps, every 90/120 Hz frame gets a new position.
        const omega = 12;
        const displacement = this.position - this.target;
        const momentum = this.velocity + omega * displacement;
        const decay = Math.exp(-omega * elapsed);
        this.position = this.target + (displacement + momentum * elapsed) * decay;
        this.velocity = (this.velocity - omega * momentum * elapsed) * decay;
        this.renderPosition();
        if (Math.abs(this.target - this.position) * this.stride < 0.25 && Math.abs(this.velocity) * this.stride < 0.25) this.finish();
        else this.frame = window.requestAnimationFrame(tick);
      };
      this.frame = window.requestAnimationFrame(tick);
    }

    finish() {
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.position = this.target = this.wrap(this.target);
      this.velocity = 0;
      this.renderPosition();
    }

    pointerDown(event) {
      if (this.dataset.swipe !== 'true' || this.slides.length < 2 || event.button > 0 || this.drag) return;
      this.suppressClick = false;
      if (event.target.closest('input, select, textarea')) return;
      if (event.pointerType !== 'touch' && event.target.closest('a, button')) return;
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.drag = { id: event.pointerId, input: event.pointerType, x: event.clientX, y: event.clientY, axis: null, position: this.position, target: this.target, lastX: event.clientX, lastY: event.clientY, time: event.timeStamp, velocity: 0 };
    }

    touchPoint(touch, event) {
      return { pointerId: touch.identifier, pointerType: 'touch', button: 0, clientX: touch.clientX, clientY: touch.clientY, target: event.target, timeStamp: event.timeStamp, preventDefault: () => { if (event.cancelable) event.preventDefault(); } };
    }

    cancelDrag() {
      if (!this.drag) return;
      this.pointerEnd({ pointerId: this.drag.id, clientX: this.drag.lastX, clientY: this.drag.lastY, timeStamp: this.drag.time }, false);
    }

    pointerMove(event) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      const point = event;
      const dx = point.clientX - drag.x;
      const dy = point.clientY - drag.y;
      if (!drag.axis) {
        if (Math.abs(dx) > 3 && Math.abs(dx) >= Math.abs(dy) * 0.85) drag.axis = 'x';
        else if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx) * 1.35) drag.axis = 'y';
        else return;
        if (drag.axis === 'x') {
          if (this.frame !== null) window.cancelAnimationFrame(this.frame);
          this.frame = null;
          drag.position = this.position;
          if (drag.input !== 'touch') this.setPointerCapture?.(event.pointerId);
          this.classList.add('is-dragging');
        } else {
          this.startMotion();
        }
      }
      if (drag.axis !== 'x') return;
      event.preventDefault();
      const elapsed = point.timeStamp - drag.time;
      if (elapsed > 0 && elapsed < 100) drag.velocity = drag.velocity * 0.5 - (point.clientX - drag.lastX) / elapsed / this.stride * 0.5;
      else if (elapsed >= 100) drag.velocity = 0;
      drag.lastX = point.clientX;
      drag.lastY = point.clientY;
      drag.time = point.timeStamp;
      this.position = drag.position - dx / this.stride;
      if (this.dragFrame === null) this.dragFrame = window.requestAnimationFrame(() => {
        this.dragFrame = null;
        this.renderPosition();
      });
    }

    pointerEnd(event, accept) {
      const drag = this.drag;
      if (!drag || event.pointerId !== drag.id) return;
      this.drag = null;
      if (this.dragFrame !== null) window.cancelAnimationFrame(this.dragFrame);
      this.dragFrame = null;
      if (drag.input !== 'touch' && this.hasPointerCapture?.(event.pointerId)) this.releasePointerCapture(event.pointerId);
      this.classList.remove('is-dragging');
      if (drag.axis !== 'x') { this.startMotion(); return; }
      this.suppressClick = true;
      if (accept) this.position = drag.position - (event.clientX - drag.x) / this.stride;
      if (event.timeStamp - drag.time > 100) drag.velocity = 0;
      this.velocity = accept ? Math.max(-3, Math.min(3, drag.velocity * 1000)) : 0;
      const projected = this.position + (accept ? drag.velocity * 180 : 0);
      let target = accept ? Math.round(projected) : drag.target;
      if (accept && target === drag.target && Math.abs(event.clientX - drag.x) > Math.min(60, this.stride * 0.15)) {
        target += event.clientX < drag.x ? 1 : -1;
      }
      target = Math.max(drag.target - 1, Math.min(drag.target + 1, target));
      this.select(target);
    }

    bindButton(button, options) {
      const fill = button.querySelector('.hero-caption__button-fill');
      if (!fill) return;
      let animation;
      const side = event => event.clientY < button.getBoundingClientRect().top + button.offsetHeight / 2 ? '-76%' : '76%';
      button.addEventListener('pointerenter', event => {
        if (event.pointerType === 'touch' || this.motion.matches) return;
        const current = animation?.playState === 'running' ? getComputedStyle(fill).transform : `translateY(${side(event)})`;
        animation?.cancel();
        animation = fill.animate([{ transform: current }, { transform: 'translateY(0)' }], { duration: 550, easing: 'cubic-bezier(0.3, 1, 0.3, 1)', fill: 'forwards' });
        button.classList.add('is-hovered');
      }, options);
      button.addEventListener('pointerleave', event => {
        if (event.pointerType === 'touch') return;
        const current = getComputedStyle(fill).transform;
        animation?.cancel();
        animation = fill.animate([{ transform: current }, { transform: `translateY(${side(event)})` }], { duration: this.motion.matches ? 0 : 450, easing: 'cubic-bezier(0.3, 1, 0.3, 1)', fill: 'forwards' });
        button.classList.remove('is-hovered');
      }, options);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('contact-submit-hover')) {
    customElements.define('contact-submit-hover', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const button = this.querySelector('button');
        const fill = this.querySelector('.contact-submit__fill');
        if (!button || !fill) return;
        const sweep = (event, entering) => {
          if (event.pointerType === 'touch' || button.disabled || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          const from = entering ? 'translateY(76%)' : getComputedStyle(fill).transform;
          this.animation?.cancel();
          this.animation = fill.animate([
            { transform: from },
            { transform: entering ? 'translateY(0)' : 'translateY(-76%)' }
          ], { duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 600, easing: 'ease', fill: 'forwards' });
        };
        button.addEventListener('pointerenter', event => sweep(event, true), { signal: this.controller.signal });
        button.addEventListener('pointerleave', event => sweep(event, false), { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.animation?.cancel();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('white-apple-benefits')) {
    customElements.define(
      'white-apple-benefits',
      class WhiteAppleBenefits extends HTMLElement {
        connectedCallback() {
          if (this.connected) return;
          this.connected = true;
          this.track = this.querySelector('[data-benefits-track]');
          this.slides = [...this.querySelectorAll('[data-benefit-slide]')];
          this.dots = [...this.querySelectorAll('[data-benefit-dot]')];
          this.pagination = this.querySelector('.store-benefits__pagination');
          this.status = this.querySelector('[data-benefits-status]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.index = 0;
          this.frame = 0;
          if (!this.track || this.slides.length < 1) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;
          this.addEventListener('carousel:advance', () => {
            if (this.mobileQuery.matches) this.goTo((this.index + 1) % this.slides.length, false);
          }, { signal });
          this.track.addEventListener('pointerdown', () => { this.announce = true; }, { signal });
          this.track.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
          this.pagination?.addEventListener('click', (event) => this.onDotClick(event), { signal });
          this.pagination?.addEventListener('keydown', (event) => this.onDotKeydown(event), { signal });
          document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
          this.onMediaChange = () => this.syncMode();
          this.mobileQuery.addEventListener('change', this.onMediaChange);

          this.resizeObserver = window.ResizeObserver ? new ResizeObserver(() => this.schedule()) : null;
          this.resizeObserver?.observe(this.track);
          this.slides.forEach((slide) => this.resizeObserver?.observe(slide));
          this.syncMode();
        }

        disconnectedCallback() {
          this.connected = false;
          this.controller?.abort();
          this.mobileQuery?.removeEventListener('change', this.onMediaChange);
          this.resizeObserver?.disconnect();
          if (this.frame) window.cancelAnimationFrame(this.frame);
        }

        syncMode() {
          const mobile = this.mobileQuery.matches;
          this.classList.toggle('is-mobile-carousel', mobile);
          if (mobile) {
            this.setAttribute('role', 'region');
            this.setAttribute('aria-roledescription', 'carousel');
            this.setAttribute('aria-label', this.dataset.carouselLabel);
            this.track.removeAttribute('role');
            this.slides.forEach((slide) => {
              slide.setAttribute('role', 'group');
              slide.setAttribute('aria-roledescription', 'slide');
              slide.setAttribute('aria-label', slide.dataset.benefitLabel);
            });
            this.update(false);
            return;
          }

          this.removeAttribute('role');
          this.removeAttribute('aria-roledescription');
          this.removeAttribute('aria-label');
          this.track.setAttribute('role', 'list');
          this.slides.forEach((slide) => {
            slide.setAttribute('role', 'listitem');
            slide.removeAttribute('aria-roledescription');
            slide.removeAttribute('aria-label');
            slide.removeAttribute('aria-hidden');
          });
          if (this.status) this.status.textContent = '';
        }

        schedule() {
          if (!this.mobileQuery.matches || this.frame) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = 0;
            this.update(this.announce !== false);
          });
        }

        update(announce) {
          if (!this.mobileQuery.matches) return;
          const trackRect = this.track.getBoundingClientRect();
          const rtl = window.getComputedStyle(this.track).direction === 'rtl';
          const nextIndex = this.slides.reduce((closest, slide, index) => {
            const slideRect = slide.getBoundingClientRect();
            const distance = Math.abs(rtl ? trackRect.right - slideRect.right : trackRect.left - slideRect.left);
            return distance < closest.distance ? { index, distance } : closest;
          }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
          const changed = nextIndex !== this.index;
          this.index = nextIndex;
          this.slides.forEach((slide, index) => {
            slide.setAttribute('aria-hidden', String(index !== this.index));
          });
          this.dots.forEach((dot, index) => {
            const active = index === this.index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-pressed', String(active));
            if (active) dot.setAttribute('aria-current', 'step');
            else dot.removeAttribute('aria-current');
            dot.tabIndex = active ? 0 : -1;
          });
          if (announce && changed && this.status) {
            this.status.textContent = this.slides[this.index].dataset.benefitLabel;
          }
        }

        goTo(index, announce = true) {
          const slide = this.slides[index];
          if (!slide) return;
          this.announce = announce;
          const trackRect = this.track.getBoundingClientRect();
          const slideRect = slide.getBoundingClientRect();
          const rtl = window.getComputedStyle(this.track).direction === 'rtl';
          this.track.scrollBy({
            behavior: this.reduceMotionQuery.matches ? 'auto' : 'smooth',
            left: rtl ? slideRect.right - trackRect.right : slideRect.left - trackRect.left
          });
        }

        onDotClick(event) {
          const dot = event.target.closest('[data-benefit-dot]');
          if (!dot || !this.contains(dot)) return;
          this.goTo(Number(dot.dataset.benefitDot));
        }

        onDotKeydown(event) {
          const dot = event.target.closest('[data-benefit-dot]');
          if (!dot) return;
          const current = this.dots.indexOf(dot);
          let next = current;
          if (event.key === 'ArrowLeft') next = Math.max(0, current - 1);
          else if (event.key === 'ArrowRight') next = Math.min(this.dots.length - 1, current + 1);
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.dots.length - 1;
          else return;
          event.preventDefault();
          this.dots[next]?.focus();
          this.goTo(next);
        }

        onBlockSelect(event) {
          const slide = event.target.closest('[data-benefit-slide]');
          if (!slide || !this.contains(slide)) return;
          this.goTo(this.slides.indexOf(slide));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
